// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__9DwK5","colBig":"styles_colBig__xIwTj","colSmall":"styles_colSmall__2InTX"};